import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {WageAccrual, WageAccrualSearchParams} from '@accounting/_common/models/wage-document.models';

export const CheckState = createAction(
    '[WageAccruals] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: WageAccrual[] } }>()
);

export const CheckStateSuccess = createAction(
    '[WageAccruals] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: WageAccrual[] } }>()
);

export const LoadList = createAction(
    '[WageAccruals] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[WageAccruals] Load List Success',
    props<{ payload: { items: WageAccrual[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[WageAccruals] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[WageAccruals] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[WageAccruals] Set Filter',
    props<{ payload: WageAccrualSearchParams }>()
);

export const SetLoading = createAction(
    '[WageAccruals] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[WageAccruals] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[WageAccruals] Update Item Success',
    props<{ payload: WageAccrual }>()
);

export const DeleteItem = createAction(
    '[WageAccruals] Delete Item',
    props<{ payload: WageAccrual }>()
);

export const DeleteItemSuccess = createAction(
    '[WageAccruals] Delete Item Success',
    props<{ payload: WageAccrual }>()
);

export const DeleteItemFailure = createAction(
    '[WageAccruals] Delete Item Failure',
    props<{ payload: WageAccrual }>()
);

export const SetInitialState = createAction(
    '[WageAccruals] Set Initial State'
);
